import { AppBar, Box, styled, Toolbar } from '@mui/material';

export const CustomAppBar = styled(AppBar)(() => ({
    background: 'none',
    boxShadow: 'none',
    height: '134px',
}));

export const CustomToolBar = styled(Toolbar)(() => ({
    height: '100%',
}));

export const CustomToolBarLeftBox = styled(Box)(() => ({
    width: '25%',
    display: 'flex',
    justifyContent: 'flex-start',
}));

export const CustomToolBarMiddleBox = styled(Box)(() => ({
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
}));

export const CustomToolBarRightBox = styled(Box)(() => ({
    width: '25%',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '16px',
}));
